import { render } from "./EdificioInstrumentadoView.vue?vue&type=template&id=f662d83e"
import script from "./EdificioInstrumentadoView.vue?vue&type=script&lang=js"
export * from "./EdificioInstrumentadoView.vue?vue&type=script&lang=js"

import "./EdificioInstrumentadoView.vue?vue&type=style&index=0&id=f662d83e&lang=scss"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__